import React from "react";
import { MobileStepper } from '@mui/material';
import { ProgressBar } from '../../../../../components/Styles';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ProgressMobileStepper = ({ activeStep, steps }) => {

  return (
    <MobileStepper
      variant="progress"
      steps={steps}
      position="static"
      activeStep={activeStep}
      sx={ProgressBar}
    />
  )

}

export default ProgressMobileStepper
